import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class Link extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = { 
      isDisabled : this.props.config && this.props.config.isDisabled || false,
    }

    this.config = { 
      types : [
        {
          title: 'default',
          isDefault: true,
        },
        'arrow'
      ],
      modifiers : [
        "inverse"
      ],
      states : []
    }
  }
  
  render() {
    const { dataLink, children, ...rest } = this.props
    const props = clearProps(this.props)
    return (this.props.default || !this.props.arrow) ? <a {...props} className={"mdn-Link mdn-Link-anchor " + this.props.className}>
      {children}
    </a> : <div className={resolveProps(this.props, this.config,'Link') + (this.props.arrow ? ' mdn-Link--arrow' : '')}>
      <a {...this.props} className="mdn-Link-anchor">
        {children}
        {this.props.arrow ? <span className="mdn-Link-anchor-icon mdn-Icon--md mdn-Icon-direita" /> : (dataLink.icon ? <span className={`mdn-Icon-${dataLink.icon}`} /> : '')}
      </a>
    </div>
  }
}

Link.propTypes = {
  config : PropTypes.object,
  disabled : PropTypes.bool,
  children : PropTypes.node,
  dataLink : PropTypes.object
}